"use client";

// components/common/TypeWriter/index.jsx
import React, { useState, useEffect, useRef } from "react";
import "./TypeWriter.css";

const TypeWriter = ({ text, speed = 50 }) => {
    const [displayText, setDisplayText] = useState("");
    const animationRef = useRef(null);
    const [isTyping, setIsTyping] = useState(true);

    useEffect(() => {
        // Clear any existing animation
        if (animationRef.current) {
            clearTimeout(animationRef.current);
        }

        // Reset state when text changes
        setDisplayText("");
        setIsTyping(true);

        let index = 0;
        const typeCharacter = () => {
            if (index < text.length) {
                setDisplayText(text.substring(0, index + 1));
                index++;
                animationRef.current = setTimeout(typeCharacter, speed);
            } else {
                setIsTyping(false);
            }
        };

        // Start typing effect
        if (text) {
            animationRef.current = setTimeout(typeCharacter, speed);
        }

        // Cleanup function
        return () => {
            if (animationRef.current) {
                clearTimeout(animationRef.current);
            }
        };
    }, [text, speed]);

    return (
        <span className="typewriter-container">
            <span className="typewriter-text">{displayText}</span>
            {isTyping && <span className="typewriter-cursor">|</span>}
        </span>
    );
};

export default TypeWriter;
